import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.keys.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
import { changeWeightAutoStatus, editWeightAllInOne, getChannelMaxCost, getErrorChannel, getMethodList, getNowWeightList, getPayWeight, getWeightStatus, setChannelMaxCost, upByErrorChannel } from '@/api/payment';
import { getChannelList, gteChannelItem } from '@/api/channel';
export default {
  name: 'ChannelDrw',
  components: {
    draggable: draggable
  },
  data: function data() {
    return {
      type: 0,
      availableChannlVisble: false,
      tableData: [],
      zeroListTableData: [],
      oneListTableData: [],
      channelsList: [],
      selectAddChannl: [],
      addOneChannel: [],
      methodList: [],
      editWeight: {
        list: [],
        type: 1
      },
      maxCash: null,
      weightNumber: 0,
      tableKey: null,
      showAuto: 0,
      displayindex: '',
      groupA: {
        name: 'itxst',
        pull: true,
        // 可以拖出
        put: true // 可以拖入
      },
      grouptable: {
        name: 'table',
        pull: false,
        put: true
      },
      grouptableA: {
        name: 'table',
        pull: 'clone',
        put: false
      }
    };
  },
  created: function created() {
    this.getStatus();
    this.getMethod();
    this.getTable();
    this.getChannls();
    this.showAvailableChannlDialog();
  },
  methods: {
    getStatus: function getStatus() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return getWeightStatus();
            case 1:
              res = _context.sent;
              if (res.code === 0) {
                _this.type = res.data.payOutStatus === '开启权重' ? 1 : 0;
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getMethod: function getMethod() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return getMethodList();
            case 1:
              res = _context2.sent;
              if (res.code === 0) {
                _this2.methodList = res.data;
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getChannls: function getChannls() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.channelsList = [];
              _context3.next = 1;
              return getChannelMaxCost({
                type: 1
              });
            case 1:
              res = _context3.sent;
              if (res.code === 0) {
                _this3.channelsList = res.data.list;
              }
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 切换数据
    switchData: function switchData(idx) {
      this.showAuto = idx;
      if (idx === 2) {
        this.errorChannl();
      } else {
        this.getTable();
      }
    },
    getTable: function getTable() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res, tableData, tableDataKey, i, tableObj, j;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this4.tableData = [];
              if (!(_this4.showAuto === 3)) {
                _context4.next = 2;
                break;
              }
              _context4.next = 1;
              return getNowWeightList({
                type: 1
              });
            case 1:
              res = _context4.sent;
              _context4.next = 4;
              break;
            case 2:
              _context4.next = 3;
              return getPayWeight({
                type: 1
              });
            case 3:
              res = _context4.sent;
            case 4:
              if (res.code === 0) {
                tableData = _this4.showAuto === 3 ? res.data : res.data.listMap;
                tableDataKey = Object.keys(tableData);
                for (i = 0; i < tableDataKey.length; i++) {
                  tableObj = {
                    method: tableDataKey[i],
                    list: []
                  };
                  for (j = 0; j < tableData[tableDataKey[i]].length; j++) {
                    tableData[tableDataKey[i]][j]['number'] = j;
                    if (tableData[tableDataKey[i]][j].hasOwnProperty('notifyRate')) {
                      tableData[tableDataKey[i]][j].notifyRate = tableData[tableDataKey[i]][j].notifyRate ? tableData[tableDataKey[i]][j].notifyRate : '/';
                    }
                    if (tableData[tableDataKey[i]][j].hasOwnProperty('pullUpRate')) {
                      tableData[tableDataKey[i]][j].pullUpRate = tableData[tableDataKey[i]][j].pullUpRate ? tableData[tableDataKey[i]][j].pullUpRate : '/';
                    }
                    tableObj.list.push(tableData[tableDataKey[i]][j]);
                  }
                  _this4.tableData.push(tableObj);
                }
                if (_this4.tableData.length === 0) {
                  _this4.tableData.push({
                    method: 'GCASH',
                    list: []
                  });
                }
              }
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    errorChannl: function errorChannl() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 1;
              return getErrorChannel();
            case 1:
              res = _context5.sent;
              if (res.code === 0) {
                _this5.oneListTableData = res.data.oneList;
                _this5.zeroListTableData = res.data.zeroList;
              }
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    // 切换模式
    switchMode: function switchMode() {
      var _this6 = this;
      this.$confirm('即将' + (this.type === 0 ? '关闭' : '打开') + ', 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var res;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 1;
              return changeWeightAutoStatus({
                payType: 1,
                status: _this6.type
              });
            case 1:
              res = _context6.sent;
              _context6.next = 2;
              return _this6.getStatus();
            case 2:
              if (res.code === 0) {
                _this6.$message({
                  type: 'success',
                  message: (_this6.type === 0 ? '关闭' : '打开') + '成功'
                });
              } else {
                _this6.$message({
                  type: 'danger',
                  message: (_this6.type === 0 ? '打开' : '关闭') + '失败'
                });
              }
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))).catch(function () {
        _this6.$message({
          type: 'info',
          message: '已取消切换'
        });
      });
    },
    selectAddOneChannl: function selectAddOneChannl(e) {
      var obj = {
        channel: e[0].channel,
        channelStr: e[0].ID,
        payKey: e[1],
        weight: 0,
        maxPayInCash: 0,
        payOutLimitEnd: 0,
        payOutLimitStart: 0,
        payOutLimitWeight: 0,
        number: this.tableData[0].list.length
      };
      this.tableData[0].list.push(obj);
      this.addOneChannel = [];
    },
    showAvailableChannlDialog: function showAvailableChannlDialog() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var res, addChannlKey, i, obj;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 1;
              return getChannelList();
            case 1:
              res = _context7.sent;
              if (res.code === 0) {
                addChannlKey = Object.keys(res.data);
                for (i = 0; i < addChannlKey.length; i++) {
                  obj = {
                    ID: res.data[addChannlKey[i]],
                    channel: parseInt(addChannlKey[i]),
                    select: {
                      ID: res.data[addChannlKey[i]],
                      channel: parseInt(addChannlKey[i])
                    },
                    children: []
                  };
                  _this7.selectAddChannl.push(obj);
                }
              }
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    addAvailableChannl: function addAvailableChannl() {
      if (this.addOneChannel.length !== 2) {
        this.$message.error('请选择通道ID');
        return;
      }
      if (!this.maxCash) {
        this.$message.error('请输入最大代付限额');
        return;
      }
      this.channelsList.push({
        channel: this.addOneChannel[0].channel,
        payKey: this.addOneChannel[1],
        maxCash: this.maxCash
      });
      this.editAvailable();
      this.availableChannlVisble = false;
    },
    // 编辑可用通道
    editAvailable: function editAvailable() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var res;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 1;
              return setChannelMaxCost({
                list: _this8.channelsList,
                type: 1
              });
            case 1:
              res = _context8.sent;
              if (res.code === 0) {
                _this8.$message.success(res.msg);
              }
              _context8.next = 2;
              return _this8.getChannls();
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    editWeightOnefn: function editWeightOnefn(tableIdx, listIdx, num, type) {
      if (num !== null) {
        if (type === 1) {
          this.tableData[tableIdx].list[listIdx].weight = num;
        } else if (type === 2) {
          this.tableData[tableIdx].list[listIdx].payOutLimitWeight = num;
        } else if (type === 3) {
          this.tableData[tableIdx].list[listIdx].payOutLimitStart = num;
        } else if (type === 4) {
          this.tableData[tableIdx].list[listIdx].payOutLimitEnd = num;
        }
      }
      this.displayindex = '';
    },
    editWeightfn: function editWeightfn() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var i, k, res;
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this9.editWeight = {
                list: [],
                type: 1
              };
              if (!(!_this9.tableData[0] || !_this9.tableData[0].list || _this9.tableData[0].list.length === 0)) {
                _context9.next = 1;
                break;
              }
              _this9.$message.warning('请添加通道');
              return _context9.abrupt("return");
            case 1:
              i = 0;
            case 2:
              if (!(i < _this9.tableData.length)) {
                _context9.next = 8;
                break;
              }
              k = 0;
            case 3:
              if (!(k < _this9.tableData[i].list.length)) {
                _context9.next = 7;
                break;
              }
              if (!(_this9.tableData[i].list[k].payOutLimitStart === 0 && _this9.tableData[i].list[k].payOutLimitEnd < 0)) {
                _context9.next = 4;
                break;
              }
              _this9.$message.warning('请重新设置区间最小值');
              return _context9.abrupt("return");
            case 4:
              if (!(_this9.tableData[i].list[k].payOutLimitEnd !== 0 && _this9.tableData[i].list[k].payOutLimitStart >= _this9.tableData[i].list[k].payOutLimitEnd)) {
                _context9.next = 5;
                break;
              }
              _this9.$message.warning('请重新设置区间最大值和区间最小值');
              return _context9.abrupt("return");
            case 5:
              _this9.tableData[i].list[k]['method'] = _this9.tableData[i].method;
              _this9.editWeight.list.push(_this9.formatWeight(_this9.tableData[i].list[k]));
            case 6:
              k++;
              _context9.next = 3;
              break;
            case 7:
              i++;
              _context9.next = 2;
              break;
            case 8:
              _context9.next = 9;
              return editWeightAllInOne(_this9.editWeight);
            case 9:
              res = _context9.sent;
              if (!(res.code === 0)) {
                _context9.next = 10;
                break;
              }
              _this9.editWeight = {
                list: [],
                type: 1
              };
              _this9.$message.success('修改成功');
              _context9.next = 10;
              return _this9.getTable();
            case 10:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    restoreWeight: function restoreWeight(list) {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee0() {
        var res;
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              _context0.next = 1;
              return upByErrorChannel({
                channel: list.channel,
                payKey: list.payKey,
                initWeight: list.initWeight
              });
            case 1:
              res = _context0.sent;
              if (res.code === 0) {
                _this0.$message.success('恢复权重成功');
                _this0.errorChannl();
              }
            case 2:
            case "end":
              return _context0.stop();
          }
        }, _callee0);
      }))();
    },
    deleteUnAutoChannl: function deleteUnAutoChannl(method, idx) {
      var _this1 = this;
      this.$confirm('将此通道移除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        for (var i = 0; i < _this1.tableData.length; i++) {
          if (method === _this1.tableData[i].method) {
            _this1.tableData[i].list.splice(idx, 1);
          }
        }
        _this1.$message({
          type: 'success',
          message: '请点击表格修改完成按钮，完成删除'
        });
      }).catch(function () {
        _this1.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    addTable: function addTable(method) {
      for (var i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].method === method) {
          this.$message.warning('渠道已有');
          return;
        }
      }
      this.tableData.push({
        method: method,
        list: []
      });
    },
    // 删除通道
    removeAvailableChannle: function removeAvailableChannle(index) {
      var _this10 = this;
      this.$confirm('将此通道移除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this10.channelsList.splice(index, 1);
        _this10.editAvailable();
      }).catch(function () {
        _this10.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    clearAvailableChannl: function clearAvailableChannl() {
      this.selectAddChannl = [];
      this.maxCash = null;
      this.addOneChannel = [];
    },
    // 计算权重
    calculateWeight: function calculateWeight(list) {
      var count = 0;
      for (var i = 0; i < list.length; i++) {
        count = count + list[i].weight;
      }
      return count === 100;
    },
    formatWeight: function formatWeight(obj) {
      var lastObj = {
        channel: 0,
        method: '',
        payKey: '',
        weight: '',
        payOutLimitWeight: 0,
        payOutLimitStart: 0,
        payOutLimitEnd: 0
      };
      var lastObjKey = Object.keys(lastObj);
      for (var i = 0; i < lastObjKey.length; i++) {
        lastObj[lastObjKey[i]] = obj[lastObjKey[i]];
      }
      return lastObj;
    },
    dynamicallyLoadingData: function dynamicallyLoadingData(node, resolve) {
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee1() {
        var res, i;
        return regeneratorRuntime.wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              if (!(node.level === 1)) {
                _context1.next = 2;
                break;
              }
              _context1.next = 1;
              return gteChannelItem({
                ChannelId: node.data.channel
              });
            case 1:
              res = _context1.sent;
              if (res.code === 0) {
                if (res.data.list) {
                  for (i = 0; i < res.data.list.length; i++) {
                    if (res.data.list[i]['Type'] === 'PAYIN' || !res.data.list[i]['Status']) {
                      res.data.list.splice(i, 1);
                      i = i - 1;
                    } else {
                      res.data.list[i]['select'] = res.data.list[i].ID;
                    }
                  }
                }
                resolve(res.data.list);
              }
              _context1.next = 3;
              break;
            case 2:
              resolve([]);
            case 3:
            case "end":
              return _context1.stop();
          }
        }, _callee1);
      }))();
    },
    grouptableEnd: function grouptableEnd() {
      var editIndex = 0;
      var editMethdIndex = 0;
      var editMethod = '';
      var editChannl = {};
      var flag = false;
      for (var i = 0; i < this.tableData.length; i++) {
        for (var j = 0; this.tableData[i].list.length; j++) {
          if (!this.tableData[i].list[j]) break;
          if (this.tableData[i].list[j]['maxCash']) {
            editMethod = this.tableData[i].method;
            editIndex = i;
            editMethdIndex = j;
            editChannl = this.tableData[i].list[j];
            break;
          }
        }
        if (editMethod) {
          break;
        }
      }
      for (var _j = 0; _j < this.tableData[editIndex].list.length; _j++) {
        if (editMethdIndex !== _j) {
          if (this.tableData[editIndex].list[_j].payKey === editChannl.payKey) {
            this.tableData[editIndex].list.splice(editMethdIndex, 1);
            this.tableKey = Math.random(1000);
            this.$message.warning('通道已有');
            flag = true;
            break;
          }
        }
        if (flag) break;
      }
      if (!flag) {
        var list = this.tableData[editIndex].list[editMethdIndex];
        this.tableData[editIndex].list.splice(editMethdIndex, 1);
        list.weight = 0;
        if (this.showAuto !== 4) {
          list['maxPayInCash'] = list.maxCash;
          list['type'] = 0;
          list['typeStr'] = '代付通道';
          list['number'] = this.tableData.length;
          list['payOutLimitWeight'] = 0;
          list['payOutLimitStart'] = 0;
          list['payOutLimitEnd'] = 0;
        } else {
          list['schemeName'] = this.handWeightOptionOnce;
        }
        this.tableData[editIndex]['list'].push(list);
        this.tableKey = Math.random(1000);
      }
    }
  }
};